// extracted by mini-css-extract-plugin
export default {"button":"MobileDebugOverlay-module__button___yRm_N","overlay":"MobileDebugOverlay-module__overlay___dpjaI","visible":"MobileDebugOverlay-module__visible___aqlGF"};